import React, { useCallback, useMemo } from "react";
import { connect } from "react-redux";
import FormField from "../../dynamicFormBuilder/FormField";
import { AdditionalLayout } from "./Layout";

// Additional tab for the IM Transaction Entry form (Delphi uIMD0019 "Additional"): Comment + Import File Name.
// Binds the same shared formFields as the Primary tab, so COMMENT/IMPORTFILENAME already round-trip via Form.js.
function AdditionalTab(props) {
    const currentUser = props.oidc?.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;

    const finalLayout = useMemo(() => AdditionalLayout, []);

    const handleSelectionChange = useCallback((name, value, e) => {
        props.handleFieldChange(name, value, e);
    }, [props.handleFieldChange]);

    // No coded dropdowns on this tab; onFormLoad is a required no-op for the dynamic builder.
    const handleFormLoad = useCallback(() => {}, []);

    return (
        <div>
            <FormField
                currrentUser={currentUser}
                layoutId="0019d019-3b56-4d78-c2e9-0019ccddee02"
                layoutName="IMTransactionEntryAdditionalForm"
                defaultFormSchema={finalLayout}
                formFields={props.formFields}
                setformFields={props.setformFields}
                handleFieldValueChange={handleSelectionChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={props.formRefs}
                onFormLoad={handleFormLoad}
            />
        </div>
    );
}

function mapStateToProps(state) {
    return { oidc: state.oidc };
}

export default connect(mapStateToProps)(AdditionalTab);
